import { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import { useReactToPrint } from "react-to-print";

import logo from "../../../assets/images/logo_nsf.png";
import "./pl.css";

import PGservice from "../../../service/ERP/PG.service.js";

import { Button, Typography, Flex } from "antd";
import { PiPrinterFill } from "react-icons/pi";
import { BACKEND_URL_MAIN } from "../../../utils/util.js";
// import { capitalizeFirst } from "../../../utils/utils";
// const pspService = ProductSpecificationService();
function PlPrintPreview() {
  const { code } = useParams();
  const componentRef = useRef(null);
  const printRef = useRef(null);
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    documentTitle: "Print This Document",
    onBeforePrint: () => {
      handleBeforePrint();
      handleCheckMultiPages();
    },
    onAfterPrint: () => {
      // restore any forced page breaks to default after print
      const parm = document.getElementById("form-body-main");
      if (parm) parm.style.pageBreakBefore = "auto";
      console.log("after printing...");
    },
    removeAfterPrint: true,
  });

  const pgService = PGservice();

  const [header, setHeader] = useState({});
  const [detail, setDetail] = useState([]);
  const [pgImages, setPgImages] = useState([]);

  const withBackendUrl = (url) => {
    if (!url) return null;

    if (/^https?:\/\//i.test(url)) return url;

    const base = (BACKEND_URL_MAIN || "").replace(/\/+$/, "");
    if (!base) return url;

    if (url.startsWith("/")) return `${base}${url}`;
    return `${base}/${url}`;
  };

  const resolveDetailImageSrc = (row) => {
    const directUrl =
      row?.image_url ||
      row?.img_url ||
      row?.image ||
      row?.img ||
      row?.file_url ||
      row?.url;

    if (directUrl) return withBackendUrl(directUrl);

    const fileName = row?.file_name || row?.filename;
    const stcode = row?.stcode || row?.mat_code;
    if (fileName && stcode)
      return withBackendUrl(`/uploads/ERP/Items/${stcode}/${fileName}`);

    return null;
  };

  const handleBeforePrint = (e) => {
    // const newElement = document.createElement('div');
    // newElement.id = 'new-container'; // Optional: Set an ID for the new container
    // newElement.innerHTML = 'TEST';
    // Render the new component into the new container
    // Replace the old container with the new container
    // componentRef.current.innerHTML = 'TEST';
  };

  const handleCheckMultiPages = () => {
    const limitPage = 930;

    const head = document.getElementById("form-head");
    // const step = document.getElementById("form-body-step");
    const parm = document.getElementById("form-body-main");

    // const othr = document.getElementById("form-body-other");

    // clear previous forced page break before measuring
    if (parm) parm.style.pageBreakBefore = "auto";

    const getHeight = (el) =>
      el
        ? Number(
            window
              .getComputedStyle(el)
              .getPropertyValue("height")
              ?.replace("px", ""),
          )
        : 0;

    let headHieght = getHeight(head);
    // let stepHieght = Number(
    //   window
    //     .getComputedStyle(step)
    //     .getPropertyValue("height")
    //     ?.replace("px", "")
    // );
    let parmHieght = getHeight(parm);

    // let othrHieght = Number(window.getComputedStyle(othr).getPropertyValue('height')?.replace("px", ""));
    // console.log( {headHieght, stepHieght, parmHieght, othrHieght} );
    if (headHieght + parmHieght > limitPage) {
      if (parm) parm.style.pageBreakBefore = "always";
      headHieght = 0;
      //   stepHieght = 0;
    }

    // if( headHieght + stepHieght + parmHieght + othrHieght > limitPage ){
    //     othr.style.pageBreakBefore = 'always';
    // }

    printRef.current = componentRef.current;

    return printRef.current;
  };

  const PrintComponent = () => {
    return (
      <div className="pl-pg-page-form" ref={componentRef}>
        <table style={{ width: "100%", fontFamily: "inherit" }}>
          <thead>
            <tr>
              <th>
                <PrintHeaderPage />
              </th>
            </tr>
          </thead>
          <tbody>
            <tr id="form-head">
              <td>
                <HeaderData />
              </td>
            </tr>
            <tr id="form-body-main">
              <td>
                <BodyDataMain />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  };

  const HeaderData = () => {
    const kv = [
      { k: "Customer/ลูกค้า", v: header?.cusname || "" },
      {
        k: "Product name",
        v: header?.product_name || header?.pg_name || "",
      },
      { k: "Product code/โค้ด", v: header?.product_code || "" },
      { k: "Brand / แบรนด์", v: header?.brand || "" },
      // {
      //   k: "Packaging/ขนาดบรรจุ",
      //   v: header?.packing_name || header?.packing_code || "",
      // },
      { k: "Net weight", v: header?.net_weight || "" },
      { k: "Unit/cs", v: header?.unit_cs || "" },
      { k: "สารก่อภูมิแพ้", v: header?.allergen || "" },
      {
        k: "Ink format / รูปแบบอิงค์",
        v: header?.ink_name || "",
      },      
      {
        k: "",
        v: header?.ink_description_1 || "",
        full: true,
      },
      {
        k: "",
        v: header?.ink_description_2 || "",
        full: true,
      },

      {
        k: "",
        v: header?.ink_description_3 || "",
        full: true,
      },
    ].filter((row) => {
      const v = (row?.v ?? "").toString().trim();
      const k = (row?.k ?? "").toString().trim();
      return v !== "" || k !== "";
    });

    return (
      <div className="head-data pl-head">
        <div className="pl-kv-grid">
          {kv.map((row, index) => (
            <div
              className={`pl-kv-row${row?.full ? " pl-kv-row--full" : ""}`}
              key={`${row.k || "row"}-${index}`}
            >
              <div className="pl-kv-key">{row.k}</div>
              <div className="pl-kv-val">{row.v}</div>
            </div>
          ))}
        </div>
      </div>
    );
  };

  const BodyDataMain = () => {
    const rows = (() => {
      const list = Array.isArray(detail) ? [...detail] : [];
      const pgPreviewRows = Array.from({ length: 2 }, (_, index) => {
        const imageRow = pgImages?.[index] || null;

        return {
          __pg_preview: true,
          __blank_image: !imageRow,
          typename: imageRow ? "Packing Goods" : "",
          mat_code: imageRow ? header?.pg_code || "" : "",
          mat_name: imageRow ? header?.pg_name || header?.product_name || "" : "",
          file_name: imageRow?.file_name,
          stcode: imageRow?.stcode || header?.pg_code,
        };
      });

      const headerImgUrl =
        header?.img_url ||
        (header?.ink_id && header?.file_name
          ? `/uploads/ERP/Ink/${header.ink_id}/${header.file_name}`
          : header?.file_name);

      if (headerImgUrl) {
        list.unshift({
          __header_img: true,
          image_url: headerImgUrl,
          typename: "รูปภาพอิงค์",
          // mat_code: header?.product_code || header?.pg_code,
          // mat_name: header?.product_name || header?.pg_name,
          description: "",
        });
      }

      return [...pgPreviewRows, ...list];
    })();

    return (
      <div className="body-data">
        <div className="pl-material-grid">
          {rows.map((row, index) => {
            const imgSrc = resolveDetailImageSrc(row);
            const key =
              row?.__header_img
                ? `header-img-${header?.pg_code || header?.product_code || ""}`
                : (row?.id ??
                  `${row?.mat_code || "pg"}-${row?.mat_code || "mat"}-${index}`);
                  
            return (
              <div className="pl-material-item" key={key}>
                <div className="pl-thumb">
                  {imgSrc ? (
                    <img
                      className="pl-thumb-img"
                      src={imgSrc}
                      alt={row?.mat_name || row?.typename || "PG image"}
                    />
                  ) : row?.__blank_image ? null : (
                    <span className="pl-thumb-empty">No image</span>
                  )}
                </div>

                {!row?.__blank_image ? (
                  <div className="pl-material-meta">
                    {!!row?.typename ? (
                      <div className="pl-meta-title">{row.typename}</div>
                    ) : null}
                    {!!row?.mat_code ? (
                      <div className="pl-meta-code">{row.mat_code}</div>
                    ) : null}
                    {!!row?.mat_name ? (
                      <div className="pl-meta-name">{row.mat_name}</div>
                    ) : null}
                    {!!row?.description ? (
                      <div className="pl-meta-desc">{row.description}</div>
                    ) : null}
                  </div>
                ) : null}
              </div>
            );
          })}
        </div>
      </div>
    );
  };

  const FooterForm = () => {
    return (
      <div className="print-foot" style={{ height: 34 }}>
        <div className="print-title flex justify-start">
          <Flex className="mb-0">
            <Typography.Text className="text-sm" strong>
              This is a computer-generated document and requires no signature.
            </Typography.Text>
          </Flex>
        </div>
      </div>
    );
  };

  const PrintHeaderPage = () => {
    return (
      <div className="head-page">
        <div className="print-logo">
          <img src={logo} alt="Company logo" />
        </div>
        <div className="print-head">
          <p className="th-text">Packing Information</p>
          {/* <p className="ts-text">
            154/23 หมู่ 2 ตำบล บึง อำเภอ ศรีราชา จังหวัด ชลบุรี รหัสไปรษณีย์ 20230
          </p>
          <p className="ts-text">
            Tel. 038-064-613 -614 Fax.038-064-567
          </p> */}
        </div>
      </div>
    );
  };

  useEffect(() => {
    if (componentRef.current) {
      const computedStyle = window.getComputedStyle(componentRef.current);
      const heightWithUnit = computedStyle.getPropertyValue("height");

      console.log("Component height:", heightWithUnit);
    }
  }, []);

  useEffect(() => {
    const init = () => {
      // alert(version)
      pgService.printpl(code).then(async (res) => {
        const { data, detail, pgImages } = res.data;

        setHeader(data);
        setDetail(detail);
        setPgImages(Array.isArray(pgImages) ? pgImages : []);

      });
    };
    init();
  }, [code]);

  return (
    <div className="page-show" id="pl-pg">
      <div className="title-preview">
        <Button
          className="bn-center bg-blue-400"
          onClick={handlePrint}
          icon={<PiPrinterFill style={{ fontSize: "1.1rem" }} />}
        >
          PRINT
        </Button>
      </div>
      <div className="print-layout-page">
        <PrintComponent />
      </div>
      <div className="hidden">
        <div ref={printRef}></div>
      </div>
    </div>
  );
}

export default PlPrintPreview;
